export const accountTypes = {
    vendor: "vendedor | vendedores",
    customer: "cliente | clientes",
    organization: "organización | organizaciones",
    user: "Usuario | Usuarios",
    affiliate: "afiliado | afiliados",
    activeVendors: "Vendedores activos"
}